import { LeftSideDefaultClassName } from 'app/src/features/Shopping/shared/utils'
import type { shoppingApi } from 'app/src/services/welfareportal'
import { CatalogSummaryButtonInformativeDialog, Tag } from 'app/src/shared/components'
import { VoucherIcon } from 'app/src/shared/components/Icons'
import { useTranslation } from 'app/src/shared/hooks'

export function MultiVoucherLeftPanelSide(
  props: { order: shoppingApi.OrderDetails; statusMode?: boolean; className?: string } & {
    showUsageModal: boolean
    setShowUsageModal: (flg: boolean) => void
    showBtnUsage: boolean
  },
) {
  const { t } = useTranslation('shopping', { keyPrefix: 'Direct' })

  return (
    <div className={props.className ?? LeftSideDefaultClassName}>
      <div className='flex flex-row'>
        <div>
          <VoucherIcon />
        </div>
        <div className='pl-4'>
          <div>
            {typeof props.statusMode !== 'undefined' && props.statusMode ? (
              <Tag pt={{ root: { className: 'mt-0 mb-0 h-[28px]' } }} tag={t('StateMapping')[props.order.status]?.label} />
            ) : (
              t('MultiVoucher.productDescription')
            )}
          </div>
          <div
            className='mt-4 max-w-lg text-2xl font-bold'
            dangerouslySetInnerHTML={{ __html: props.order.product?.productName ?? '' }}
          />
          {props.showBtnUsage && (
            <CatalogSummaryButtonInformativeDialog
              setShowModal={props.setShowUsageModal}
              showModal={props.showUsageModal}
              bannerId='VOUCHERUSAGE'
            />
          )}
        </div>
      </div>
    </div>
  )
}
